export const EVALUATION_ROUND_STATUSES = {
  running: "running",
  completed: "completed",
};

export const EVALUATION_SUB_TABS = {
  applicants: "applicants",
  company: "company",
};

export const APPLICANT_EVALUATION_STATUSES = {
  pending: "pending",
  done: "done",
};

/** Server-side cap on the evaluation form's detailed feedback (422 beyond it). */
export const EVALUATION_FEEDBACK_MAX_LENGTH = 300;

/** FE-defined criteria template for the client's blank satisfaction-survey form.
 * There is no criteria-catalogue endpoint (out of scope), so the client rates
 * this fixed set. `section` / `attribute_name` are the server-facing English
 * strings sent in the POST `attributes_data`; `key` maps to the localized UI
 * label and to the RatingForm state. */
export const CLIENT_SURVEY_CRITERIA = [
  { key: "serviceQuality", section: "Service & Quality", attribute_name: "Service quality" },
  { key: "attentionToDetail", section: "Service & Quality", attribute_name: "Attention to detail" },
  { key: "understandingRequests", section: "Service & Quality", attribute_name: "Understanding requests" },
  { key: "speedOfResponse", section: "Reliability & Support", attribute_name: "Speed of response" },
  { key: "complaintResolutionSpeed", section: "Reliability & Support", attribute_name: "Complaint resolution speed" },
  { key: "wayOfResolvingComplaints", section: "Reliability & Support", attribute_name: "Way of resolving complaints" },
  { key: "compliance", section: "Financial & Admin", attribute_name: "Compliance" },
  { key: "adminFinanceCooperation", section: "Financial & Admin", attribute_name: "Admin/Finance cooperation" },
  { key: "priceTermsOfPayments", section: "Financial & Admin", attribute_name: "Price/terms of payments" },
];

/** Reverse lookups for localizing a stored survey response, whose `section` /
 * `attribute_name` are the server-facing English strings above. Both map back to
 * the i18n keys under `evaluationsTab.companyTab.criteriaGroups` / `criteria`. */
export const SECTION_TO_GROUP_KEY = {
  "Service & Quality": "serviceAndQuality",
  "Reliability & Support": "reliabilityAndSupport",
  "Financial & Admin": "financialAndAdmin",
};

export const ATTRIBUTE_NAME_TO_CRITERIA_KEY = CLIENT_SURVEY_CRITERIA.reduce(
  (acc, c) => ({ ...acc, [c.attribute_name]: c.key }),
  {},
);

/** Localized grouping used to render the client's blank satisfaction-survey form.
 * Keys line up with `CLIENT_SURVEY_CRITERIA[].key` and the i18n labels under
 * `evaluationsTab.companyTab.criteria` / `criteriaGroups`. */
export const COMPANY_CRITERIA_GROUPS = [
  {
    key: "serviceAndQuality",
    criteriaKeys: ["serviceQuality", "attentionToDetail", "understandingRequests"],
  },
  {
    key: "reliabilityAndSupport",
    criteriaKeys: ["speedOfResponse", "complaintResolutionSpeed", "wayOfResolvingComplaints"],
  },
  {
    key: "financialAndAdmin",
    criteriaKeys: ["compliance", "adminFinanceCooperation", "priceTermsOfPayments"],
  },
];
